module.exports = __webpack_public_path__ + "static/media/maaseudunterveysjalomahuoltoLogo.a832bd21.png";